export type HttpError = Error & { status?: number };

export function createUnauthenticatedError(message: string): HttpError {
  return Object.assign(new Error(message), { status: 401 });
}

export function isUnauthenticatedError(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    'status' in error &&
    error.status === 401
  );
}
